import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { Routes } from '../../routes';

import { SearchResultsScreen } from 'features/search/SearchResults';
import { ProductDetailsScreen } from 'features/product/ProductDetailScreen';
import { CheckoutScreen } from 'features/order-summary/screens/CheckoutScreen';
import { AccountSettingsScreen } from 'features/account-settings/screens/AccountSettingsScreen';
import { WalletRoutes } from 'features/wallet/WalletRoutes';
import { HomepageScreen } from 'features/homepage/HomepageScreen';
import {
    BrandsOnBonus,
    ShopOnlineBrandsOnBonus,
} from 'features/landing-pages/brands-on-bonus/BrandsOnBonus';
import { Favorites } from 'features/landing-pages/favorites/Favorites';
import { FeaturedBrands } from 'features/landing-pages/featured-brands/FeaturedBrands';
import { LocalProductScreen } from 'features/product/LocalProductScreen';
import { Metadata } from 'components/metadata';
import { MetadataPage } from 'components/metadata/constants';
import { ByEarnTypePage } from './ByEarnTypePage';
import { EarnTypeConstructorFilter } from 'common/api/constructor/util';
import { withAuth } from 'features/auth/components/withAuth';
import { EarnMorePage } from './EarnMorePage';
import { EarnMoreByTypePage } from './EarnMoreByTypePage';

const AuthedEarnTypePage = withAuth(Routes.ShopOnline)(() => (
    <ByEarnTypePage earnType={EarnTypeConstructorFilter.ShopOnline} />
));

const ShopRoutes = () => (
    <Switch>
        <Route path={Routes.Shop} exact>
            <Metadata page={MetadataPage.shop}>
                <HomepageScreen />
            </Metadata>
        </Route>
        <Route path={Routes.ShopEarnMore} exact>
            <EarnMorePage />
        </Route>
        <Route path={Routes.ShopEarnMoreByType} exact>
            <EarnMoreByTypePage />
        </Route>
        <Route path={Routes.ShopOnline} exact>
            <AuthedEarnTypePage />
        </Route>
        <Route path={Routes.ShopGiftCards} exact>
            <ByEarnTypePage earnType={EarnTypeConstructorFilter.GiftCards} />
        </Route>
        <Route path={Routes.ShopOrderScreen}>
            <Metadata page={MetadataPage['shop/order']}>
                <CheckoutScreen />
            </Metadata>
        </Route>
        <Route path={Routes.Brands} exact>
            <Metadata page={MetadataPage.brands}>
                <SearchResultsScreen />
            </Metadata>
        </Route>
        <Route path={Routes.ShopLocalProductDetails} exact component={LocalProductScreen} />
        <Route path={Routes.BrandsDetails} component={ProductDetailsScreen} />
        <Route path={Routes.ShopAccountSettings}>
            <Metadata page={MetadataPage['shop/account']}>
                <AccountSettingsScreen />
            </Metadata>
        </Route>
        <Route path={Routes.WalletMyCards}>
            <Metadata page={MetadataPage['shop/wallet']}>
                <WalletRoutes />
            </Metadata>
        </Route>
        <Route path={Routes.OnBonus} exact>
            <Metadata page={MetadataPage['on-bonus']}>
                <BrandsOnBonus />
            </Metadata>
        </Route>
        <Route path={Routes.ShopOnlineOnBonus} exact>
            <Metadata page={MetadataPage['shop-online-bonus']}>
                <ShopOnlineBrandsOnBonus />
            </Metadata>
        </Route>
        <Route path={Routes.Favorites} exact>
            <Metadata page={MetadataPage.favorites}>
                <Favorites />
            </Metadata>
        </Route>
        <Route path={Routes.Featured} exact>
            <Metadata page={MetadataPage['featured-brands']}>
                <FeaturedBrands />
            </Metadata>
        </Route>
    </Switch>
);

export default ShopRoutes;
